module.exports = __webpack_public_path__ + "static/chantry-e01f098504d4722b93535aef61bf4c21.jpg";